<template>
  <div>
    <StockAddNew
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-card style="height: 100%">
      <b-row class="justify-content-md-start" v-if="!isMobile()">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterStockList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterStockList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>

        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
        <b-col>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium"
            >
              <span class="mr-2 leading-none">{{ $t("TotalActions") }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  deleteStock();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Delete") }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  pullStockList();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("PullStock") }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-start" v-else>
        <b-col cols="6">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterStockList"
              size="sm"
            />
          </b-form-group>
        </b-col>

        <b-col cols="2" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterStockList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="4" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
        <b-col>
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium"
            >
              <span class="mr-2 leading-none">{{ $t("TotalActions") }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  deleteStock();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("Delete") }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item
                @click="
                  wholeStockActions = true;
                  pullStockList();
                "
              >
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t("PullStock") }}</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </b-col>
      </b-row>

      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="stockColumns"
        :defaultColDef="defaultColDef"
        :rowData="stockList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        :pagination="true"
      >
      </ag-grid-vue>
    </vs-card>
    <vs-popup
      :active.sync="bulkStockPopup"
      :title="$t('PullStock')"
      @cancel="clearFields"
      @close="clearFields"
    >
      <div style="min-height: 350px">
        <b-row>
          <b-col v-if="ROLE != 'Company'">
            <b-row class="mb-2">
              <b-col cols="3" align-self="center">
                <b-form-group
                  :label="'* ' + $t('Customer') + ': '"
                  class="vs-input--label pr-0 mr-0"
                  label-for="h-first-name"
                >
                </b-form-group>
              </b-col>
              <b-col cols="9">
                <v-select
                  color="danger"
                  v-model="customer"
                  :options="customer_choices"
                  size="small"
                  label="CompanyName"
                  v-on:input="
                    getCustomerMarketplaces();
                    getCustomerDepoList();
                  "
                  autocomplete
                  ref="selectElement"
                >
                </v-select>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="3" align-self="center">
            <b-form-group
              :label="'* ' + $t('Marketplace') + ': '"
              class="vs-input--label pr-0 mr-0"
              label-for="h-first-name"
            >
            </b-form-group>
          </b-col>
          <b-col cols="9">
            <v-select
              v-model="marketplace"
              label="Name"
              :options="marketplace_choices"
              size="small"
              autocomplete
              ref="selectElement"
            >
              <template slot="option" slot-scope="option">
                <b-row>
                  <b-col cols="2">
                    <img
                      v-if="mpControl(option.Name)"
                      :src="
                        require('../../assets/images/logo/' + option.Name.trim() + '.png')
                      "
                      width="30"
                      v-b-tooltip.hover.bottom="option.Name"
                      @error="errorImage"
                    />
                  </b-col>
                  <b-col>
                    {{ option.Prefix }} -
                    {{ option.Name }}
                  </b-col>
                </b-row>
              </template>
            </v-select>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="3" align-self="center">
            <b-form-group
              :label="'* ' + $t('Storehouse') + ': '"
              class="vs-input--label pr-0 mr-0"
              label-for="h-first-name"
            >
            </b-form-group>
          </b-col>
          <b-col cols="9">
            <v-select
              color="danger"
              v-model="storehouse"
              :options="storehouse_choices"
              size="small"
              label="name"
              autocomplete
              ref="selectElement"
              name="storehouse"
              v-validate="'required'"
            >
            </v-select>

            <span class="text-danger text-sm" v-show="errors.has('storehouse')">{{
              errors.first("storehouse")
            }}</span>
          </b-col>
        </b-row>
        <b-row style="margin-top: 50px; text-align: center">
          <b-col>
            <b-button
              style="background-color: white; border-color: white; font-size: 30px"
              class="vs-con-loading__container"
              id="loading-pull-stock"
              v-on:click="pullStock()"
              v-b-tooltip.hover.bottom="$t('PullStock')"
              v-if="customer && marketplace && storehouse"
            >
              <h1 class="text-primary">{{ $t("PullStock") }}</h1>
            </b-button>
            <b-button
              style="background-color: white; border-color: white; font-size: 30px"
              class="vs-con-loading__container"
              id="loading-pull-stock"
              v-on:click="pullStock()"
              v-b-tooltip.hover.bottom="$t('PullStock')"
              disabled
              v-else
            >
              <h1 class="text-primary">{{ $t("PullStock") }}</h1>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </vs-popup>
    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
  </div>
</template>
<script>
import { uuid } from "vue-uuid";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import moment from "moment";
import { isMobile } from "mobile-device-detect";
import StockAddNew from "./StockAddNew.vue";
import SuccessBtn from "../../components/vx-button/SuccessBtn.vue";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue";
import i18nData from "../../i18n/i18nData";
import TextViewCellRenderer from "../CellRenderers/TextViewCellRenderer.vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      customer: "",
      bulkStockPopup: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      paginationPageSize: null,
      paginationPageSizeSelector: null,
      wholeStockActions: false,
      stockListFiltered: [],
      allBarcodesData: [],
      barcodeData: [],
      isBarcodeAddActive: false,
      deleteData: [{}],
      deleteWarningPromptValid: false,
      stockList: [],
      stockColumns: [],
      marketplace_choices: [],
      storehouse_choices: [],
      storehouseForCustomerList: [],
      storehouse: "",
      marketplace: "",
      searchedVal: "",
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarAct: {},
      isMobile: function () {
        return isMobile;
      },
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
    };
  },
  computed: {
    company: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    //get stock list from store
    stock: {
      get() {
        return this.$store.state.stock.Stock;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  components: {
    vSelect,
    TextViewCellRenderer,
    uuid,
    statusShowCellRenderer,
    DeleteWarning,
    updateDeleteBtnCellRenderer,
    AgGridVue,
    StockAddNew,
    Icon,
    SuccessBtn,
  },
  methods: {
    getCustomerDepoList() {
      const vs = this.$vs;
      this.storehouse_choices = [];
      this.$store
        .dispatch("storehouse/listStorehouseForCompany", this.customer.CompanyId)
        .then((response) => {
          // let costumerList = JSON.parse(response.json);
          if (response.success == true) {
            console.log(response);

            this.storehouseForCustomerList = JSON.parse(response.json);
            this.storehouseForCustomerList.forEach((val, index) => {
              this.storehouse_choices.push({ value: val.DepotId, name: val.DepotName });
            });
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
    mpControl(e) {
      if (
        !e.includes("Toplu") &&
        !e.includes("Flip") &&
        !e.includes("Php") &&
        !e.includes("Tümü")
      )
        return true;
      else return false;
    },
    errorImage(e) {
      if (e.type == "error")
        e.target.src = "https://int.kamyonyedekparca.com/img/404picture.jpg";
    },
    getCustomerMarketplaces() {
      const vs = this.$vs;
      this.timelineData = [];
      this.$store
        .dispatch("customer/listCustomerInfoForCustomer", this.customer.CompanyId)
        .then((response) => {
          // let costumerList = JSON.parse(response.json);
          if (response.success == true) {
            console.log(response);
            this.marketplace_choices = JSON.parse(response.json);
          } else console.log(response.statusText);
          /*	vs.notify({
						text: response.statusText,
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "danger",
						position: "top-center"
					});*/
        });
    },
    clearFields() {
      this.$root.$emit("closePalletItemsPopup2", false);
    },
    pullStock() {
      let type = "material";
      var vs = this.$vs;
      if (this.marketplace == "" || this.customer == "" || this.storehouse == "") {
        vs.notify({
          text: this.$t("Validate"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          position: "top-center",
        });
      } else {
        vs.loading({
          container: `#loading-pull-stock`,
          type,
          scale: 0.75,
        });
        let obj = {
          companyInfoId: this.marketplace.CompanyInfoId,
          depotId: this.storehouse.value,
        };
        this.$store
          .dispatch("stock/pullStock", obj)
          .then((response) => {
            console.log(response);

            if (response.data.success == true) {
              this.getStockList();
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              setTimeout(() => {
                vs.loading.close("#loading-pull-stock> .con-vs-loading");
              }, 1000);
            } else {
							setTimeout(() => {
                vs.loading.close("#loading-pull-stock> .con-vs-loading");
              }, 1000);
              vs.notify({
                text: response.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          })
          .catch((error) => {
            return new Promise((resolve, reject) => {
              resolve(false);
            });
          });
      }
    },
    pullStockList() {
      this.bulkStockPopup = true;
    },
    deleteSubmitAll() {
      var selectedRows = this.gridApi.getSelectedRows();
      selectedRows.forEach((val, index) => {
        this.deleteSubmit(val);
      });
    },

    filterStockList() {
      this.stockList = this.stockListFiltered;
      this.stockList = this.stockList.filter((post) => {
        return (
          post.StockName.toUpperCase().includes(this.searchedVal.toUpperCase()) ||
          post.Stockno.toUpperCase().includes(this.searchedVal.toUpperCase())
        );
      });
    },
    addBarcodePopup(data) {
      this.barcodeData = data;
      this.isBarcodeAddActive = true;
    },
    toggleDataSidebarBarcode(val = false) {
      this.isBarcodeAddActive = val;
    },
    deleteSubmit(data) {
      console.log(data);
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteStock", data.StockId)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getStockList();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    deleteStock() {
      this.deleteWarningPromptValid = true;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    updateCustomer(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    getStockList() {
      const vs = this.$vs;
      this.stockList = [];
      this.stockColumns = [];
      this.stockList = this.stock;
      this.stockListFiltered = this.stock;
      if (this.stockList.length > 0) {
        let columnList = Object.keys(this.stockList[0]);
        this.stockColumns.push({
          headerCheckboxSelection: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,

          width: 130,
          pinned: "left",
          cellRendererFramework: "updateDeleteBtnCellRenderer",
        });
        columnList.forEach((val, index) => {
          if (
            val == "DepotName" ||
            val == "Stockno" ||
            val == "CustomerStockNo" ||
            val == "CompanyName" ||
            val == "StockName" ||
            val == "CompanyInfoName"
          ) {
            if (this.isMobile())
              this.stockColumns.push({
                width: 150,
                headerName: this.$t(val),
                field: val,
                filter: "agSetColumnFilter",
                cellRendererFramework: "TextViewCellRenderer",
              });
            else
              this.stockColumns.push({
                width: 150,
                headerName: this.$t(val),
                pinned: "left",
                field: val,
                filter: "agSetColumnFilter",
                cellRendererFramework: "TextViewCellRenderer",
              });
          } else if (val == "Status")
            this.stockColumns.push({
              width: 80,
              headerName: this.$t(val),
              cellRendererFramework: "statusShowCellRenderer",
              field: val,
              filter: "agSetColumnFilter",
            });
          else if (
            val != "ActSupplierId" &&
            val != "DepotId" &&
            val != "CompanyInfoId" &&
            val != "CompanyId" &&
            val != "StockId" &&
            val != "UnitId" &&
            val.toString().includes("Date") == false
          )
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          else if (val.toString().includes("Date") == true) {
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
            });
          }
        });
      }
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },

    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("addNewData", () => {
      this.addNewData();
    });
    this.$root.$on("deleteDataBtn", (data) => {
      this.deleteData = data;
      this.deleteStock(data);
    });
    this.$root.$on("getStockList", () => {
      this.getStockList();
    });
    this.$root.$on("editDataBtn", (data) => {
      this.updateCustomer(data);
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
    this.$root.$on("deleteSubmit", (data) => {
      if (this.wholeStockActions == true) this.deleteSubmitAll();
      else this.deleteSubmit(data);
    });
    this.$root.$on("closeBarcodePopup", () => {
      this.toggleDataSidebarBarcode(false);
    });
    this.$root.$on("addBarcodePopup", (data) => {
      this.addBarcodePopup(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("deleteDataBtn");
    this.$root.$off("addNewData");
    this.$root.$off("getStockList");
    this.$root.$off("editDataBtn");
    this.$root.$off("closeDeleteWarning");
    this.$root.$off("deleteSubmit");
    this.$root.$off("addBarcodePopup");
    this.$root.$off("closeBarcodePopup");
  },
  watch: {
    company(val) {
      this.customer_choices = val;
      return val;
    },
    stock(val) {
      this.getStockList();

      return val;
    },
  },
  created() {
    this.getStockList();
    this.customer_choices = this.company;
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
